// 数据来源：《全国航海院校和培训机构.xlsx》“航海院校清单及培训机构”工作表 B1:C288。
// 仅保留机构名称和类型；空白分隔行已排除，机构名称作为实际保存值。
export const CREW_SCHOOL_OPTIONS = [
  { name: '北部湾大学', type: '本科' },
  { name: '渤海大学', type: '本科' },
  { name: '重庆交通大学', type: '本科' },
  { name: '大连海事大学', type: '本科' },
  { name: '大连海洋大学', type: '本科' },
  { name: '广东海洋大学', type: '本科' },
  { name: '广州航海学院', type: '本科' },
  { name: '集美大学', type: '本科' },
  { name: '宁波大学', type: '本科' },
  { name: '泉州师范学院', type: '本科' },
  { name: '山东交通学院', type: '本科' },
  { name: '上海海事大学', type: '本科' },
  { name: '天津理工大学', type: '本科' },
  { name: '武汉理工大学', type: '本科' },
  { name: '烟台大学', type: '本科' },
  { name: '浙江海洋大学', type: '本科' },
  { name: '海南科技职业大学', type: '本科（民办）' },
  { name: '九江科技职业大学', type: '本科（民办）' },
  { name: '安徽交通职业技术学院', type: '专科' },
  { name: '滨州职业学院', type: '专科' },
  { name: '大连职业技术学院(大连开放大学)', type: '专科' },
  { name: '福建船政交通职业学院', type: '专科' },
  { name: '广东交通职业技术学院', type: '专科' },
  { name: '河北建材职业技术学院', type: '专科' },
  { name: '河北交通职业技术学院', type: '专科' },
  { name: '河南交通职业技术学院', type: '专科' },
  { name: '湖北交通职业技术学院', type: '专科' },
  { name: '江苏海事职业技术学院', type: '专科' },
  { name: '江苏航运职业技术学院', type: '专科' },
  { name: '青岛港湾职业技术学院', type: '专科' },
  { name: '青岛远洋船员职业学院', type: '专科' },
  { name: '山东交通职业学院', type: '专科' },
  { name: '山东理工职业学院', type: '专科' },
  { name: '上海海事职业技术学院', type: '专科' },
  { name: '上海交通职业技术学院', type: '专科' },
  { name: '四川交通职业技术学院', type: '专科' },
  { name: '唐山海运职业学院有限公司', type: '专科' },
  { name: '天津海运职业学院', type: '专科' },
  { name: '威海职业学院', type: '专科' },
  { name: '武汉船舶职业技术学院', type: '专科' },
  { name: '武汉航海职业技术学院', type: '专科' },
  { name: '武汉交通职业学院', type: '专科' },
  { name: '厦门海洋职业技术学院', type: '专科' },
  { name: '新乡职业技术学院', type: '专科' },
  { name: '延安职业技术学院', type: '专科' },
  { name: '浙江国际海运职业技术学院', type: '专科' },
  { name: '浙江交通职业技术学院', type: '专科' },
  { name: '北京交通运输职业学院', type: '专科' },
  { name: '渤海船舶职业学院', type: '专科' },
  { name: '重庆交通职业学院', type: '专科' },
  { name: '广东生态工程学院', type: '专科' },
  { name: '贵州交通职业大学', type: '专科' },
  { name: '海南热带海洋学院', type: '专科' },
  { name: '湖北黄冈应急管理职业技术学院', type: '专科' },
  { name: '湖北三峡职业技术学院', type: '专科' },
  { name: '湖南交通职业技术学院', type: '专科' },
  { name: '九江职业技术学院', type: '专科' },
  { name: '宁波工程学院', type: '专科' },
  { name: '山东化工职业学院', type: '专科' },
  { name: '上海南湖职业技术学院', type: '专科' },
  { name: '武汉海事职业学院', type: '专科' },
  { name: '新疆交通职业技术学院', type: '专科' },
  { name: '云南交通运输职业学院', type: '专科' },
  { name: '大连航运职业技术学院', type: '专科（民办）' },
  { name: '泉州海洋职业学院', type: '专科（民办）' },
  { name: '日照航海工程职业学院', type: '专科（民办）' },
  { name: '三亚航空旅游职业学院', type: '专科（民办）' },
  { name: '山东海事职业学院', type: '专科（民办）' },
  { name: '安徽省航运技工学校', type: '中专' },
  { name: '沧州海事学校', type: '中专' },
  { name: '常州交通技师学院', type: '中专' },
  { name: '重庆市第二交通技工学校', type: '中专' },
  { name: '重庆万州技师学院', type: '中专' },
  { name: '大连航运职业技术学校', type: '中专' },
  { name: '福建海洋职业技术学校', type: '中专' },
  { name: '福建航运学校', type: '中专' },
  { name: '福建交通职业技术学校', type: '中专' },
  { name: '福建莆田航海职业技术学校', type: '中专' },
  { name: '广东省城市技师学院', type: '中专' },
  { name: '广东省交通运输高级技工学校', type: '中专' },
  { name: '广州海运技工学校', type: '中专' },
  { name: '广州潜水学校', type: '中专' },
  { name: '哈尔滨航运学校（黑龙江省交通干部学校）', type: '中专' },
  { name: '江苏省大港中等专业学校', type: '中专' },
  { name: '江苏省无锡交通高等职业技术学校', type: '中专' },
  { name: '江苏省盐城技师学院', type: '中专' },
  { name: '江苏省扬州技师学院', type: '中专' },
  { name: '乐山市知行旅游职业高中有限公司', type: '中专' },
  { name: '连云港市交通技工学校', type: '中专' },
  { name: '普洱市职业教育中心', type: '中专' },
  { name: '秦皇岛兴荣海事中等职业学校', type: '中专' },
  { name: '青岛海运职业学校', type: '中专' },
  { name: '泉州海事学校', type: '中专' },
  { name: '泉州市泉港航运职业中专学校', type: '中专' },
  { name: '潍坊华洋水运学校', type: '中专' },
  { name: '芜湖海事职业技术学校', type: '中专' },
  { name: '梧州市交通职业技术学校', type: '中专' },
  { name: '襄阳技师学院', type: '中专' },
  { name: '烟台海员职业中等专业学校', type: '中专' },
  { name: '漳州海事职业技术学校', type: '中专' },
  { name: '镇江蓝天职业技术学校有限公司', type: '中专' },
  { name: '舟山航海学校', type: '中专' },
  { name: '三明市三技交通培训服务中心', type: '培训机构' },
  { name: '铜陵市中等职业技术教育中心', type: '培训机构' },
  { name: '安徽海船经济技术合作有限公司', type: '培训机构' },
  { name: '安康市汉滨区宏达船员培训中心', type: '培训机构' },
  { name: '安庆市长江船员职业培训学校', type: '培训机构' },
  { name: '安庆市江海船员职业培训学校', type: '培训机构' },
  { name: '蚌埠市船员职业培训学校', type: '培训机构' },
  { name: '包头市平安航运有限责任公司', type: '培训机构' },
  { name: '长沙金舟船员培训中心', type: '培训机构' },
  { name: '池州市海诚船员职业培训学校', type: '培训机构' },
  { name: '池州市徽航船员职业培训学校', type: '培训机构' },
  { name: '赤水利航船员职业培训有限公司', type: '培训机构' },
  { name: '重庆长航船员培训有限公司', type: '培训机构' },
  { name: '重庆市川维职业培训学校', type: '培训机构' },
  { name: '重庆市渝中区晨云船员职业培训学校', type: '培训机构' },
  { name: '达州市光华职业技术培训学校', type: '培训机构' },
  { name: '大连航海家游艇俱乐部有限公司', type: '培训机构' },
  { name: '大连环海海员培训中心', type: '培训机构' },
  { name: '大连乐航游艇俱乐部有限公司', type: '培训机构' },
  { name: '大连松辽蓝色梦想游艇驾驶技术培训有限公司', type: '培训机构' },
  { name: '大连展翔游艇俱乐部有限公司', type: '培训机构' },
  { name: '丹东鸿利海运有限公司', type: '培训机构' },
  { name: '当涂县铸学职业培训学校', type: '培训机构' },
  { name: '东山华毅游艇培训有限公司', type: '培训机构' },
  { name: '东山骏燊游艇有限公司', type: '培训机构' },
  { name: '东莞市四海船员培训中心', type: '培训机构' },
  { name: '丰城市船员职业培训学校', type: '培训机构' },
  { name: '佛山市瑞海船员服务有限公司', type: '培训机构' },
  { name: '福鼎市海员职业培训学校', type: '培训机构' },
  { name: '福州海昇船员管理有限公司', type: '培训机构' },
  { name: '福州中汽游艇管理有限公司', type: '培训机构' },
  { name: '阜阳市船员职业培训学校', type: '培训机构' },
  { name: '甘肃鑫港船员培训有限公司', type: '培训机构' },
  { name: '广东省大洋安全培训有限公司', type: '培训机构' },
  { name: '广西贵港恒伟船员培训有限公司', type: '培训机构' },
  { name: '广西华晨船务服务有限公司', type: '培训机构' },
  { name: '广西聚新海洋教育科技有限公司', type: '培训机构' },
  { name: '广西中辉船员培训服务有限公司', type: '培训机构' },
  { name: '广元市汽车驾驶员培训学校有限公司', type: '培训机构' },
  { name: '广州繁珠船员培训信息咨询有限公司', type: '培训机构' },
  { name: '广州海安船员培训有限公司', type: '培训机构' },
  { name: '广州航道技工学校', type: '培训机构' },
  { name: '广州航运交易所（广州国际航运研究中心）', type: '培训机构' },
  { name: '广州南沙游艇会管理有限公司', type: '培训机构' },
  { name: '广州太古仓码头游艇发展有限公司', type: '培训机构' },
  { name: '广州新海医院', type: '培训机构' },
  { name: '贵港市恒基职业技能培训有限公司', type: '培训机构' },
  { name: '贵阳市水上交通行业协会', type: '培训机构' },
  { name: '贵州乌江船员技术培训有限责任公司', type: '培训机构' },
  { name: '桂林启航船务服务有限公司', type: '培训机构' },
  { name: '哈尔滨蓝海梦想游艇驾驶技术培训有限公司', type: '培训机构' },
  { name: '海南傲瀚海洋文化有限公司', type: '培训机构' },
  { name: '海南栢烁航海职业技能培训有限公司', type: '培训机构' },
  { name: '海南海飞游艇驾驶培训有限公司', type: '培训机构' },
  { name: '海南航达信息咨询有限责任公司', type: '培训机构' },
  { name: '海南航跃游艇船员培训有限公司', type: '培训机构' },
  { name: '海南鸿泽翔游艇培训有限公司', type: '培训机构' },
  { name: '海南鸿洲游艇产业发展投资集团有限公司', type: '培训机构' },
  { name: '海南华彩旅业有限公司', type: '培训机构' },
  { name: '海南聚悦航海有限责任公司', type: '培训机构' },
  { name: '海南领航博海游艇服务有限公司', type: '培训机构' },
  { name: '海南美安游艇产业发展有限公司', type: '培训机构' },
  { name: '海南南舶航海服务有限公司', type: '培训机构' },
  { name: '海南启扬博海游艇服务有限公司', type: '培训机构' },
  { name: '海南睿航航海科技有限公司', type: '培训机构' },
  { name: '海南晟旭航海培训有限责任公司', type: '培训机构' },
  { name: '海南司楠游艇产业发展有限公司', type: '培训机构' },
  { name: '海南玺海国际游艇有限公司', type: '培训机构' },
  { name: '海南兴远船员培训有限公司', type: '培训机构' },
  { name: '海南詹尼游艇船员培训有限公司', type: '培训机构' },
  { name: '杭州春江内河船舶航行安全技术咨询有限公司', type: '培训机构' },
  { name: '合肥新航船员职业培训学校', type: '培训机构' },
  { name: '河源市船员培训中心', type: '培训机构' },
  { name: '黑龙江泷海船员培训有限公司', type: '培训机构' },
  { name: '湖北高质船员培训有限公司', type: '培训机构' },
  { name: '湖北新海联船员培训有限公司', type: '培训机构' },
  { name: '湖北新海联（青岛）船员培训有限公司', type: '培训机构' },
  { name: '湖南海员海事服务有限公司', type: '培训机构' },
  { name: '湖南江海国际船员培训服务有限公司', type: '培训机构' },
  { name: '湖州江海船员职业培训学校', type: '培训机构' },
  { name: '葫芦岛骏达教育科技有限公司', type: '培训机构' },
  { name: '华洋海事（厦门）游艇培训有限公司', type: '培训机构' },
  { name: '淮安市交通职业培训学校', type: '培训机构' },
  { name: '淮南市永盛船员职业培训学校', type: '培训机构' },
  { name: '惠州市长丰海船员培训有限公司', type: '培训机构' },
  { name: '惠州市金桥船员培训有限公司', type: '培训机构' },
  { name: '吉安市赣江船员培训有限公司', type: '培训机构' },
  { name: '嘉兴市汇通水运服务有限公司', type: '培训机构' },
  { name: '江门华海船员培训中心', type: '培训机构' },
  { name: '江门市江中珠游艇会有限公司', type: '培训机构' },
  { name: '江门市蓬江区丰帆船员培训中心', type: '培训机构' },
  { name: '江苏金风科技有限公司', type: '培训机构' },
  { name: '江苏御风海上安全咨询服务有限公司', type: '培训机构' },
  { name: '江西威斯特水上体育发展有限公司', type: '培训机构' },
  { name: '江西幸福船员管理有限公司', type: '培训机构' },
  { name: '交通运输部管理干部学院', type: '培训机构' },
  { name: '锦州致远海员培训有限公司', type: '培训机构' },
  { name: '荆州领航船员职业技能培训有限公司', type: '培训机构' },
  { name: '九江海韵船员培训有限公司', type: '培训机构' },
  { name: '九江航海船员管理有限公司', type: '培训机构' },
  { name: '来宾市万豪船员服务有限公司', type: '培训机构' },
  { name: '兰溪市三江船员培训学校', type: '培训机构' },
  { name: '丽水华航职业培训有限公司', type: '培训机构' },
  { name: '柳州市兴华船员专业培训中心', type: '培训机构' },
  { name: '六安市船员职业培训学校', type: '培训机构' },
  { name: '泸州市江阳区顺风船员培训有限公司', type: '培训机构' },
  { name: '马鞍山市星航联船员职业培训学校', type: '培训机构' },
  { name: '南京鸿汇水上培训有限公司', type: '培训机构' },
  { name: '南京泰航教育科技有限公司', type: '培训机构' },
  { name: '南京油运海员培训中心有限公司', type: '培训机构' },
  { name: '内江市东兴区丰雨职业技能培训学校', type: '培训机构' },
  { name: '宁德市安洋船员培训有限公司', type: '培训机构' },
  { name: '宁夏农艺职业技能培训学校', type: '培训机构' },
  { name: '平潭综合实验区吉鹏海员培训有限公司', type: '培训机构' },
  { name: '黔东南州宏伟水上驾驶培训学校有限公司', type: '培训机构' },
  { name: '黔西南州众航船舶船员培训中心', type: '培训机构' },
  { name: '秦皇岛航宁船员培训有限公司', type: '培训机构' },
  { name: '秦皇岛秦皇国际游艇俱乐部有限公司', type: '培训机构' },
  { name: '秦皇岛市海港区西港航海运动培训学校', type: '培训机构' },
  { name: '秦皇岛英洋国际海事服务有限公司', type: '培训机构' },
  { name: '青岛银海游艇帆船驾驶培训学校', type: '培训机构' },
  { name: '青海育鲲船员培训有限公司', type: '培训机构' },
  { name: '清远市顺发船员培训有限公司', type: '培训机构' },
  { name: '三亚聚悦航海有限责任公司', type: '培训机构' },
  { name: '三亚一帆实业有限公司', type: '培训机构' },
  { name: '山东省船员培训中心有限公司', type: '培训机构' },
  { name: '山西海事通商务服务有限公司', type: '培训机构' },
  { name: '汕头市东澳游艇俱乐部有限公司', type: '培训机构' },
  { name: '上海晨光游艇驾驶培训有限公司', type: '培训机构' },
  { name: '上海雍和海连海事服务有限公司', type: '培训机构' },
  { name: '上饶市龙翔船员培训学校有限公司', type: '培训机构' },
  { name: '韶关市海丰航务有限公司船员培训中心', type: '培训机构' },
  { name: '绍兴市玛德船员培训有限公司', type: '培训机构' },
  { name: '深圳市海汉子游艇管理有限公司', type: '培训机构' },
  { name: '深圳市鹏星船务有限公司', type: '培训机构' },
  { name: '深圳市七星湾游艇会有限公司', type: '培训机构' },
  { name: '深圳市纵横四海航海俱乐部有限公司', type: '培训机构' },
  { name: '沈阳浑河航运经营有限公司', type: '培训机构' },
  { name: '石家庄正顺船员培训有限公司', type: '培训机构' },
  { name: '四川激池交通工程技术咨询有限公司', type: '培训机构' },
  { name: '苏州市新苏船员职业培训学校', type: '培训机构' },
  { name: '泰州市地方海事船检协会', type: '培训机构' },
  { name: '天津弘盛科技有限公司', type: '培训机构' },
  { name: '天津津滨游艇俱乐部有限公司', type: '培训机构' },
  { name: '天津市交通教育培训中心', type: '培训机构' },
  { name: '芜湖市新江河船员职业培训学校', type: '培训机构' },
  { name: '武汉航道海事服务有限公司', type: '培训机构' },
  { name: '武汉瑞亚海事服务有限公司', type: '培训机构' },
  { name: '厦门杰鹏游艇有限公司', type: '培训机构' },
  { name: '厦门市海员培训中心', type: '培训机构' },
  { name: '厦门五缘游艇文化发展有限公司', type: '培训机构' },
  { name: '新蔡县江豫职业培训学校', type: '培训机构' },
  { name: '新野县安达船员职业培训学校', type: '培训机构' },
  { name: '信阳市豫淮船员职业培训学校', type: '培训机构' },
  { name: '徐州市华顺船员培训有限公司', type: '培训机构' },
  { name: '宣城市天盛船员职业培训学校有限公司', type: '培训机构' },
  { name: '阳城县九女仙湖景区开发有限公司船员培训中心', type: '培训机构' },
  { name: '依琳娜游艇（泉州）有限公司', type: '培训机构' },
  { name: '乙宁游艇（宁德）有限公司', type: '培训机构' },
  { name: '益阳扬帆船员职业培训学校', type: '培训机构' },
  { name: '营口兴港船员培训有限公司', type: '培训机构' },
  { name: '郁南县西江船员培训有限公司', type: '培训机构' },
  { name: '湛江市海翔企业管理有限公司', type: '培训机构' },
  { name: '湛江市经海船员培训中心', type: '培训机构' },
  { name: '漳州市龙文港鑫交通培训中心', type: '培训机构' },
  { name: '肇庆市西江船员培训中心有限公司', type: '培训机构' },
  { name: '浙江金风科技有限公司', type: '培训机构' },
  { name: '浙江省海运集团温州船员培训有限公司', type: '培训机构' },
  { name: '镇江鸿欣船务有限公司', type: '培训机构' },
  { name: '中国海洋工程有限公司', type: '培训机构' },
  { name: '中海油安全技术服务有限公司', type: '培训机构' },
  { name: '中海油(广东)安全健康科技有限责任公司', type: '培训机构' },
  { name: '中宏船员培训（连云港）有限公司', type: '培训机构' },
  { name: '中交上海航道局有限公司', type: '培训机构' },
  { name: '中交天津航道局有限公司', type: '培训机构' },
  { name: '中能海（深圳）海洋技术开发有限公司', type: '培训机构' },
  { name: '中山市盛邦船员培训有限公司', type: '培训机构' },
  { name: '中石化胜利石油工程有限公司', type: '培训机构' },
  { name: '中石化胜利石油工程有限公司培训中心', type: '培训机构' },
  { name: '舟山市聚能职业技能培训学校有限公司', type: '培训机构' },
  { name: '周口市港航船员职业培训学校', type: '培训机构' },
  { name: '珠海九洲船员培训中心有限公司', type: '培训机构' },
  { name: '驻马店市新领航职业技能培训学校', type: '培训机构' },
]
